import { render, staticRenderFns } from "./ReleasesDigitalDistributionReadOnlyPanel.vue?vue&type=template&id=7ae0f2c4"
import script from "./ReleasesDigitalDistributionReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./ReleasesDigitalDistributionReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./ReleasesDigitalDistributionReadOnlyPanel.vue?vue&type=style&index=0&id=7ae0f2c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports